var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	52217: () => (loadStrictSingletonVersion("default", "@angular/compiler", false, [2,19,2,3], () => (__webpack_require__.e("node_modules_angular_compiler_fesm2022_compiler_mjs").then(() => (() => (__webpack_require__(/*! @angular/compiler */ 45568))))))),
	1267: () => (loadStrictSingletonVersion("default", "@angular/core", false, [2,19,2,3], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs").then(() => (() => (__webpack_require__(/*! @angular/core */ 37580))))))),
	5573: () => (loadStrictSingletonVersion("default", "@angular/common", false, [2,19,2,3], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_common_mjs-_b4621").then(() => (() => (__webpack_require__(/*! @angular/common */ 60316))))))),
	53266: () => (loadStrictVersion("default", "rxjs/operators", false, [2,7,8,1], () => (__webpack_require__.e("node_modules_rxjs_dist_esm_operators_index_js").then(() => (() => (__webpack_require__(/*! rxjs/operators */ 98219))))))),
	57082: () => (loadStrictVersion("default", "rxjs", false, [2,7,8,1], () => (__webpack_require__.e("node_modules_rxjs_dist_esm_index_js").then(() => (() => (__webpack_require__(/*! rxjs */ 80845))))))),
	27523: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/signals", false, [2,19,2,3], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_primitives_signals_mjs-_22bb1").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 85689))))))),
	97127: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/di", false, [2,19,2,3], () => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 52867))))),
	98395: () => (loadStrictSingletonVersion("default", "@angular/common/http", false, [2,19,2,3], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_http_mjs-_f9341").then(() => (() => (__webpack_require__(/*! @angular/common/http */ 46443))))))),
	64910: () => (loadStrictSingletonVersion("default", "@angular/platform-browser", false, [2,19,2,3], () => (__webpack_require__.e("node_modules_angular_platform-browser_fesm2022_platform-browser_mjs-_e89f1").then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))))))),
	21079: () => (loadStrictVersion("default", "lodash", false, [1,4,17,21], () => (__webpack_require__.e("node_modules_lodash_lodash_js").then(() => (() => (__webpack_require__(/*! lodash */ 46227))))))),
	53550: () => (loadStrictSingletonVersion("default", "@ca-webstack/reflection", false, [2,19,0,1], () => (__webpack_require__.e("node_modules_ca-webstack_reflection_bundles_ca-webstack_reflection_umd_js").then(() => (() => (__webpack_require__(/*! @ca-webstack/reflection */ 23549))))))),
	56028: () => (loadStrictSingletonVersion("default", "@ca-webstack/data-structures", false, [2,19,0,1], () => (__webpack_require__.e("node_modules_ca-webstack_data-structures_bundles_ca-webstack_data-structures_umd_js").then(() => (() => (__webpack_require__(/*! @ca-webstack/data-structures */ 55701))))))),
	71350: () => (loadStrictSingletonVersion("default", "@ca-webstack/change-tracker", false, [2,19,0,1], () => (__webpack_require__.e("node_modules_ca-webstack_change-tracker_bundles_ca-webstack_change-tracker_umd_js-_02e71").then(() => (() => (__webpack_require__(/*! @ca-webstack/change-tracker */ 62365))))))),
	14527: () => (loadStrictSingletonVersion("default", "@angular/forms", false, [2,19,2,3], () => (__webpack_require__.e("node_modules_angular_forms_fesm2022_forms_mjs-_0f7c1").then(() => (() => (__webpack_require__(/*! @angular/forms */ 34456))))))),
	1025: () => (loadStrictSingletonVersion("default", "@angular/router", false, [2,19,2,3], () => (__webpack_require__.e("node_modules_angular_router_fesm2022_router_mjs-_5a221").then(() => (() => (__webpack_require__(/*! @angular/router */ 95072))))))),
	2912: () => (loadStrictSingletonVersion("default", "@caep/ng-event-manager", false, [2,19,0,1], () => (__webpack_require__.e("node_modules_caep_ng-event-manager_fesm2022_caep-ng-event-manager_mjs-_1a571").then(() => (() => (__webpack_require__(/*! @caep/ng-event-manager */ 85013))))))),
	13941: () => (loadStrictSingletonVersion("default", "@ca-webstack/ng-policy-engine", false, [2,19,0,1], () => (__webpack_require__.e("node_modules_ca-webstack_ng-policy-engine_fesm2022_ca-webstack-ng-policy-engine_mjs-_68cd1").then(() => (() => (__webpack_require__(/*! @ca-webstack/ng-policy-engine */ 83067))))))),
	24985: () => (loadStrictVersion("default", "lodash-es", false, [1,4,17,21], () => (__webpack_require__.e("node_modules_lodash-es_lodash_js").then(() => (() => (__webpack_require__(/*! lodash-es */ 50381))))))),
	25850: () => (loadStrictSingletonVersion("default", "@ca-webstack/ng-i18n", false, [2,19,0,1], () => (__webpack_require__.e("node_modules_ca-webstack_ng-i18n_fesm2022_ca-webstack-ng-i18n_mjs-_bee31").then(() => (() => (__webpack_require__(/*! @ca-webstack/ng-i18n */ 31405))))))),
	32570: () => (loadStrictSingletonVersion("default", "@perfectmemory/ngx-contextmenu", false, [1,19,0,0], () => (__webpack_require__.e("node_modules_perfectmemory_ngx-contextmenu_fesm2022_perfectmemory-ngx-contextmenu_mjs-_86211").then(() => (() => (__webpack_require__(/*! @perfectmemory/ngx-contextmenu */ 29959))))))),
	40550: () => (loadStrictSingletonVersion("default", "ngx-toastr", false, [2,19,0,0], () => (__webpack_require__.e("node_modules_ngx-toastr_fesm2022_ngx-toastr_mjs-_f9fd1").then(() => (() => (__webpack_require__(/*! ngx-toastr */ 54285))))))),
	41067: () => (loadStrictSingletonVersion("default", "ngx-countdown", false, [4,19,0,0], () => (__webpack_require__.e("node_modules_ngx-countdown_fesm2022_ngx-countdown_mjs-_2a1e1").then(() => (() => (__webpack_require__(/*! ngx-countdown */ 81661))))))),
	52403: () => (loadStrictSingletonVersion("default", "@ca-webstack/ng-aspects", false, [2,19,0,1], () => (__webpack_require__.e("node_modules_ca-webstack_ng-aspects_fesm2022_ca-webstack-ng-aspects_mjs-_2d221").then(() => (() => (__webpack_require__(/*! @ca-webstack/ng-aspects */ 6447))))))),
	55377: () => (loadStrictSingletonVersion("default", "@ca-webstack/ng-command-dispatcher", false, [2,19,0,1], () => (__webpack_require__.e("node_modules_ca-webstack_ng-command-dispatcher_fesm2022_ca-webstack-ng-command-dispatcher_mjs-_f4601").then(() => (() => (__webpack_require__(/*! @ca-webstack/ng-command-dispatcher */ 26815))))))),
	59953: () => (loadStrictSingletonVersion("default", "ngx-mask", false, [2,19,0,6], () => (__webpack_require__.e("node_modules_ngx-mask_fesm2022_ngx-mask_mjs-_a6a61").then(() => (() => (__webpack_require__(/*! ngx-mask */ 86769))))))),
	71522: () => (loadStrictSingletonVersion("default", "@ngx-translate/core", false, [1,15,0,0], () => (__webpack_require__.e("node_modules_ngx-translate_core_dist_fesm2022_ngx-translate-core_mjs-_63781").then(() => (() => (__webpack_require__(/*! @ngx-translate/core */ 90852))))))),
	74924: () => (loadStrictSingletonVersion("default", "@angular/cdk/coercion", false, [1,19,2,19], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_coercion_mjs-_bff61").then(() => (() => (__webpack_require__(/*! @angular/cdk/coercion */ 2814))))))),
	75085: () => (loadStrictSingletonVersion("default", "@nodro7/angular-mydatepicker", false, [2,0,14,0], () => (__webpack_require__.e("node_modules_nodro7_angular-mydatepicker_fesm2022_nodro7-angular-mydatepicker_mjs-_a0be1").then(() => (() => (__webpack_require__(/*! @nodro7/angular-mydatepicker */ 88491))))))),
	3979: () => (loadStrictSingletonVersion("default", "@ca-webstack/data-context", false, [2,19,0,1], () => (__webpack_require__.e("node_modules_ca-webstack_data-context_bundles_ca-webstack_data-context_umd_js").then(() => (() => (__webpack_require__(/*! @ca-webstack/data-context */ 72693))))))),
	54246: () => (loadStrictSingletonVersion("default", "@ca-webstack/policy-engine", false, [2,19,0,1], () => (__webpack_require__.e("node_modules_ca-webstack_policy-engine_bundles_ca-webstack_policy-engine_umd_js").then(() => (() => (__webpack_require__(/*! @ca-webstack/policy-engine */ 82233))))))),
	84868: () => (loadStrictSingletonVersion("default", "@ca-webstack/ng-data-context", false, [2,19,0,1], () => (__webpack_require__.e("node_modules_ca-webstack_ng-data-context_fesm2022_ca-webstack-ng-data-context_mjs-_cb161").then(() => (() => (__webpack_require__(/*! @ca-webstack/ng-data-context */ 18573))))))),
	52498: () => (loadStrictSingletonVersion("default", "@ca-webstack/ng-serializer", false, [2,19,0,1], () => (__webpack_require__.e("node_modules_ca-webstack_ng-serializer_fesm2022_ca-webstack-ng-serializer_mjs-_368c1").then(() => (() => (__webpack_require__(/*! @ca-webstack/ng-serializer */ 6313))))))),
	74322: () => (loadStrictSingletonVersion("default", "@ca-webstack/ng-components", false, [2,19,0,1], () => (__webpack_require__.e("node_modules_ca-webstack_ng-components_fesm2022_ca-webstack-ng-components_mjs-_81b01").then(() => (() => (__webpack_require__(/*! @ca-webstack/ng-components */ 47625))))))),
	11756: () => (loadStrictSingletonVersion("default", "@ca-webstack/ng-signalr", false, [2,19,0,1], () => (__webpack_require__.e("node_modules_ca-webstack_ng-signalr_fesm2022_ca-webstack-ng-signalr_mjs-_6fca1").then(() => (() => (__webpack_require__(/*! @ca-webstack/ng-signalr */ 72031))))))),
	84034: () => (loadStrictSingletonVersion("default", "angular-oauth2-oidc", false, [1,18,0,0], () => (__webpack_require__.e("node_modules_angular-oauth2-oidc_fesm2022_angular-oauth2-oidc_mjs-_eb331").then(() => (() => (__webpack_require__(/*! angular-oauth2-oidc */ 97451))))))),
	25600: () => (loadStrictSingletonVersion("default", "@angular/cdk/overlay", false, [1,19,2,19], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_overlay_mjs-_40551").then(() => (() => (__webpack_require__(/*! @angular/cdk/overlay */ 81570))))))),
	50568: () => (loadStrictSingletonVersion("default", "@angular/cdk/portal", false, [1,19,2,19], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_portal_mjs-_b9701").then(() => (() => (__webpack_require__(/*! @angular/cdk/portal */ 9168))))))),
	53140: () => (loadStrictSingletonVersion("default", "@angular/cdk/a11y", false, [1,19,2,19], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_a11y_mjs-_ca011").then(() => (() => (__webpack_require__(/*! @angular/cdk/a11y */ 72102)))))))
};
var initialConsumes = [52217];
initialConsumes.forEach((id) => {
	__webpack_require__.m[id] = (module) => {
		// Handle case when module is used sync
		installedModules[id] = 0;
		delete __webpack_require__.c[id];
		var factory = moduleToHandlerMapping[id]();
		if(typeof factory !== "function") throw new Error("Shared module is not available for eager consumption: " + id);
		module.exports = factory();
	}
});
var chunkMapping = {
	"polyfills": [
		52217
	],
	"node_modules_angular_cdk_fesm2022_a11y_mjs-_ca010": [
		1267,
		5573,
		53266,
		57082
	],
	"node_modules_angular_cdk_fesm2022_coercion_mjs-_bff60": [
		1267
	],
	"node_modules_angular_cdk_fesm2022_collections_mjs-_c5cc0": [
		1267,
		57082
	],
	"node_modules_angular_cdk_fesm2022_drag-drop_mjs-_fbb40": [
		1267,
		5573,
		57082,
		53266
	],
	"node_modules_angular_cdk_fesm2022_layout_mjs-_77ce0": [
		1267,
		57082,
		53266,
		5573
	],
	"node_modules_angular_cdk_fesm2022_overlay_mjs-_40550": [
		1267,
		5573,
		53266,
		57082
	],
	"node_modules_angular_cdk_fesm2022_portal_mjs-_b9700": [
		1267,
		5573
	],
	"node_modules_angular_cdk_fesm2022_scrolling_mjs-_f5b00": [
		1267,
		57082,
		53266,
		5573
	],
	"node_modules_angular_common_fesm2022_http_mjs-_f9340": [
		1267,
		53266,
		57082
	],
	"node_modules_angular_common_fesm2022_common_mjs-_b4620": [
		1267,
		57082
	],
	"node_modules_angular_core_fesm2022_core_mjs": [
		27523,
		97127,
		57082,
		53266
	],
	"node_modules_angular_forms_fesm2022_forms_mjs-_0f7c0": [
		1267,
		5573,
		53266,
		57082
	],
	"node_modules_angular_platform-browser_fesm2022_animations_mjs-_f32a0": [
		1267,
		5573
	],
	"node_modules_angular_platform-browser_fesm2022_platform-browser_mjs-_e89f0": [
		1267,
		5573,
		98395
	],
	"node_modules_angular_router_fesm2022_router_mjs-_5a220": [
		1267,
		5573,
		53266,
		57082,
		64910
	],
	"node_modules_ca-webstack_change-tracker_bundles_ca-webstack_change-tracker_umd_js-_02e70": [
		21079,
		53550,
		56028,
		57082
	],
	"node_modules_ca-webstack_data-context_bundles_ca-webstack_data-context_umd_js": [
		53550,
		21079,
		71350
	],
	"node_modules_ca-webstack_ng-aspects_fesm2022_ca-webstack-ng-aspects_mjs-_2d220": [
		1267,
		14527,
		53550
	],
	"node_modules_ca-webstack_ng-command-dispatcher_fesm2022_ca-webstack-ng-command-dispatcher_mjs-_f4600": [
		1267,
		53550
	],
	"node_modules_ca-webstack_ng-components_fesm2022_ca-webstack-ng-components_mjs-_81b00": [
		1025,
		1267,
		2912,
		5573,
		13941,
		14527,
		24985,
		25850,
		32570,
		40550,
		41067,
		52403,
		53266,
		53550,
		55377,
		56028,
		57082,
		59953,
		64910,
		71522,
		74924,
		75085,
		98395
	],
	"node_modules_ca-webstack_ng-data-context_fesm2022_ca-webstack-ng-data-context_mjs-_cb160": [
		1267,
		3979
	],
	"node_modules_ca-webstack_ng-i18n_fesm2022_ca-webstack-ng-i18n_mjs-_bee30": [
		1267,
		53266,
		57082,
		71522
	],
	"node_modules_ca-webstack_ng-policy-engine_fesm2022_ca-webstack-ng-policy-engine_mjs-_68cd0": [
		1267,
		53550,
		54246
	],
	"node_modules_ca-webstack_ng-serializer_fesm2022_ca-webstack-ng-serializer_mjs-_368c0": [
		1267,
		53550
	],
	"node_modules_ca-webstack_ng-shell_fesm2022_ca-webstack-ng-shell_mjs-_4b290": [
		53550,
		3979,
		71350,
		57082,
		84868,
		52498,
		53266,
		1267,
		55377,
		74322,
		2912,
		1025,
		11756,
		5573,
		24985,
		25850
	],
	"node_modules_ca-webstack_ng-signalr_fesm2022_ca-webstack-ng-signalr_mjs-_6fca0": [
		1267,
		24985,
		52498,
		84868
	],
	"node_modules_ca-webstack_policy-engine_bundles_ca-webstack_policy-engine_umd_js": [
		57082,
		53266
	],
	"node_modules_ca-webstack_reflection_bundles_ca-webstack_reflection_umd_js": [
		56028
	],
	"node_modules_caep_ng-event-manager_fesm2022_caep-ng-event-manager_mjs-_1a570": [
		1267
	],
	"node_modules_caep_ng-graphql_fesm2022_caep-ng-graphql_mjs-_bf360": [
		1267,
		5573,
		14527,
		57082,
		53266,
		98395,
		56028,
		52498
	],
	"node_modules_dylog_oauth-client_fesm2022_dylog-oauth-client_mjs-_dc880": [
		98395,
		1267,
		84034,
		57082,
		1025
	],
	"node_modules_ngx-translate_core_dist_fesm2022_ngx-translate-core_mjs-_63780": [
		1267,
		53266,
		57082
	],
	"node_modules_nodro7_angular-mydatepicker_fesm2022_nodro7-angular-mydatepicker_mjs-_a0be0": [
		1267,
		5573,
		14527
	],
	"node_modules_perfectmemory_ngx-contextmenu_fesm2022_perfectmemory-ngx-contextmenu_mjs-_86210": [
		1267,
		5573,
		25600,
		50568,
		53140,
		57082
	],
	"node_modules_angular-oauth2-oidc_fesm2022_angular-oauth2-oidc_mjs-_eb330": [
		1267,
		5573,
		53266,
		57082,
		98395
	],
	"node_modules_ngx-countdown_fesm2022_ngx-countdown_mjs-_2a1e0": [
		1267,
		5573
	],
	"node_modules_ngx-mask_fesm2022_ngx-mask_mjs-_a6a60": [
		1267,
		5573,
		14527
	],
	"node_modules_ngx-toastr_fesm2022_ngx-toastr_mjs-_f9fd0": [
		1267,
		5573,
		57082,
		64910
	],
	"node_modules_angular_common_fesm2022_common_mjs-_b4621": [
		57082
	],
	"node_modules_angular_common_fesm2022_http_mjs-_f9341": [
		53266,
		57082
	],
	"node_modules_angular_platform-browser_fesm2022_platform-browser_mjs-_e89f1": [
		98395
	],
	"node_modules_ca-webstack_change-tracker_bundles_ca-webstack_change-tracker_umd_js-_02e71": [
		21079,
		56028,
		57082
	],
	"node_modules_angular_forms_fesm2022_forms_mjs-_0f7c1": [
		5573,
		53266,
		57082
	],
	"node_modules_angular_router_fesm2022_router_mjs-_5a221": [
		5573,
		53266,
		64910
	],
	"node_modules_ca-webstack_ng-i18n_fesm2022_ca-webstack-ng-i18n_mjs-_bee31": [
		71522
	],
	"node_modules_perfectmemory_ngx-contextmenu_fesm2022_perfectmemory-ngx-contextmenu_mjs-_86211": [
		25600,
		50568,
		53140
	],
	"node_modules_ca-webstack_ng-policy-engine_fesm2022_ca-webstack-ng-policy-engine_mjs-_68cd1": [
		54246
	],
	"node_modules_ca-webstack_ng-components_fesm2022_ca-webstack-ng-components_mjs-_81b01": [
		13941,
		14527,
		32570,
		40550,
		41067,
		52403,
		56028,
		59953,
		64910,
		71522,
		74924,
		75085,
		98395
	],
	"node_modules_ca-webstack_ng-serializer_fesm2022_ca-webstack-ng-serializer_mjs-_368c1": [
		53550
	],
	"node_modules_ca-webstack_ng-data-context_fesm2022_ca-webstack-ng-data-context_mjs-_cb161": [
		3979
	],
	"node_modules_angular-oauth2-oidc_fesm2022_angular-oauth2-oidc_mjs-_eb331": [
		5573,
		53266
	],
	"node_modules_angular_cdk_fesm2022_overlay_mjs-_40551": [
		53266
	],
	"node_modules_angular_cdk_fesm2022_a11y_mjs-_ca011": [
		53266
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}